import { render, staticRenderFns } from "./UploadAccidentPhotos.vue?vue&type=template&id=5ef0af81&scoped=true&"
import script from "./UploadAccidentPhotos.vue?vue&type=script&lang=js&"
export * from "./UploadAccidentPhotos.vue?vue&type=script&lang=js&"
import style0 from "./UploadAccidentPhotos.vue?vue&type=style&index=0&id=5ef0af81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0af81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef0af81')) {
      api.createRecord('5ef0af81', component.options)
    } else {
      api.reload('5ef0af81', component.options)
    }
    module.hot.accept("./UploadAccidentPhotos.vue?vue&type=template&id=5ef0af81&scoped=true&", function () {
      api.rerender('5ef0af81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadAccidentPhotos.vue"
export default component.exports